import React, { FunctionComponent } from 'react';
import SingleDateOfBirthStep from '../SingleDateOfBirthStep';
import { SingleFieldStepProps } from '../types';

export const getQuestion = (isPolicyIssuedToPerson: boolean): string =>
  isPolicyIssuedToPerson
    ? "What is the policy holder's date of birth?"
    : "What is the business owner's date of birth?";

const ContactDateOfBirthStep: FunctionComponent<
  Pick<SingleFieldStepProps<string>, 'defaultStateValue' | 'onNext'> & {
    isPolicyIssuedToPerson: boolean;
  }
> = ({ isPolicyIssuedToPerson, defaultStateValue, onNext }) => (
  <SingleDateOfBirthStep
    onNext={onNext}
    question={getQuestion(isPolicyIssuedToPerson)}
    stateKey={
      isPolicyIssuedToPerson
        ? 'policyHolderDateOfBirth'
        : 'businessOwnerDateOfBirth'
    }
    entityType={isPolicyIssuedToPerson ? 'policy holder' : 'business owner'}
    defaultStateValue={defaultStateValue}
  />
);

export default ContactDateOfBirthStep;
